const LOGIN_AS_TOKEN_KEY = 'login_as';
const LOGIN_AS_MAIN_TOKEN_KEY = 'login_as_main_token';
const LOGIN_AS_MAIN_LOGIN_KEY = 'login_as_main_login';
const LOGIN_AS_MAIN_ADMIN_ID_KEY = 'login_as_main_admin_id';

const buildAdminLoginData = (admin) => ({
    isLoggedIn: true,
    userData: {
        userRole: 'Admin',
        first_name: admin?.first_name || '',
        last_name: admin?.last_name || '',
    },
});

export const isLoginAsActive = () => Boolean(localStorage.getItem(LOGIN_AS_TOKEN_KEY));

export const clearLoginAsSession = () => {
    localStorage.removeItem(LOGIN_AS_TOKEN_KEY);
    localStorage.removeItem(LOGIN_AS_MAIN_TOKEN_KEY);
    localStorage.removeItem(LOGIN_AS_MAIN_LOGIN_KEY);
    localStorage.removeItem(LOGIN_AS_MAIN_ADMIN_ID_KEY);
};

export const startLoginAsSession = (authPayload) => {
    const currentToken = localStorage.getItem('token');
    const currentLogin = localStorage.getItem('login');
    const currentAdminId = localStorage.getItem('admin_id');

    if (!currentToken || !authPayload?.token || !authPayload?.admin) {
        throw new Error('Unable to start login-as session.');
    }

    if (!isLoginAsActive()) {
        localStorage.setItem(LOGIN_AS_MAIN_TOKEN_KEY, currentToken);

        if (currentLogin) {
            localStorage.setItem(LOGIN_AS_MAIN_LOGIN_KEY, currentLogin);
        }

        if (currentAdminId) {
            localStorage.setItem(LOGIN_AS_MAIN_ADMIN_ID_KEY, currentAdminId);
        }
    }

    const loginData = buildAdminLoginData(authPayload.admin);

    localStorage.setItem(LOGIN_AS_TOKEN_KEY, authPayload.token);
    localStorage.setItem('token', authPayload.token);
    localStorage.setItem('login', JSON.stringify(loginData));

    if (authPayload.admin?.id) {
        localStorage.setItem('admin_id', String(authPayload.admin.id));
    } else {
        localStorage.removeItem('admin_id');
    }

    return loginData;
};

export const restoreMainSessionAfterLoginAs = () => {
    const mainToken = localStorage.getItem(LOGIN_AS_MAIN_TOKEN_KEY);
    const mainLogin = localStorage.getItem(LOGIN_AS_MAIN_LOGIN_KEY);
    const mainAdminId = localStorage.getItem(LOGIN_AS_MAIN_ADMIN_ID_KEY);

    if (!mainToken || !mainLogin) {
        clearLoginAsSession();
        return null;
    }

    localStorage.setItem('token', mainToken);
    localStorage.setItem('login', mainLogin);

    if (mainAdminId) {
        localStorage.setItem('admin_id', mainAdminId);
    } else {
        localStorage.removeItem('admin_id');
    }

    clearLoginAsSession();

    try {
        return JSON.parse(mainLogin);
    } catch {
        return null;
    }
};

